import { Navigate, useLocation } from "react-router-dom"

const roleHomePages = {
  platform_admin: "/dashboard-pro",
  super_admin: "/dashboard-pro",
  dg: "/dashboard-pro",

  admin_maison_djo: "/maison-djo-dashboard",
  gestionnaire_maison_djo: "/maison-djo-dashboard",
  stock_maison_djo: "/stock-orders",
  livreur_maison_djo: "/stock-orders",

  admin_depot_relais: "/depot-relais-dashboard",
  gestionnaire_depot_relais: "/depot-relais-dashboard",
  stock_depot_relais: "/stock-orders",
  gerant_depot_relais: "/sales",

  gerant_magasin: "/sales",

  agent_commercial: "/customers",

  caissier_central: "/payments",
  gestionnaire_operations: "/reporting",
  gestionnaire_stock: "/stock-orders",
  controleur_stock: "/stock-audits",
  viewer: "/reporting",
}

export function getRoleHomePage(role) {
  return roleHomePages[role] || "/login"
}

function ProtectedRoute({ children, allowedRoles = [] }) {
  const location = useLocation()

  const user = localStorage.getItem("kongosys_user")
  const role = localStorage.getItem("kongosys_role")

  if (!user || !role) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location,
        }}
      />
    )
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to={getRoleHomePage(role)} replace />
  }

  return children
}

export default ProtectedRoute